import AbstractMediator from "../../../core/ui/AbstractMediator";
import Button from "../../../../../lib/html5-software-library/src/ranj/components/buttons/Button";
import SmartphoneNavigateEvent from "../model/SmartphoneNavigateEvent";
import SmartphoneSoundType from "./SmartphoneSoundType";
import EmailAddedEvent from "../../email/model/EmailAddedEvent";
import EmailConversationStatusChangedEvent from "../../email/model/EmailConversationStatusChangedEvent";

export default class SmartphoneOpenerMediator extends AbstractMediator {
    constructor(target, dispatcher, emailModel, soundManager) {
        super(target, dispatcher);

        this._target.startX = this._target.x;
        this._emailModel = emailModel;
        this._soundManager = soundManager;
    }

    initialize() {
        super.initialize();

        this._smartphoneButton = this.createButton(this._target, this._handleOpenerButton.bind(this));

        this._updateUnreadItemsIndicator();

        this.registerEventListener(EmailAddedEvent.EMAIL_ADDED_TO_CONVERSATION, this._handleSmartphoneItemAdded.bind(this));
        this.registerEventListener(EmailConversationStatusChangedEvent.STATUS_CHANGED, this._handleSmartphoneItemOpened.bind(this));
        this.registerEventListener(SmartphoneNavigateEvent.SMARTPHONE_HIDE_REQUEST, this._handleSmartphoneClose.bind(this));
    }

    _handleOpenerButton() {
        this._stopShake();

        this._target.visible = false;

        this.dispatch(SmartphoneNavigateEvent.SMARTPHONE_SHOW_REQUEST);
    }

    _handleSmartphoneClose() {
        this._target.visible = true;
    }

    _handleSmartphoneItemAdded(evt) {
        this._updateUnreadItemsIndicator();
        this._startShake();
        this._soundManager.playSound(SmartphoneSoundType.NEW_CONTENT);
    }

    _handleSmartphoneItemOpened() {
        this._updateUnreadItemsIndicator();
    }

    _updateUnreadItemsIndicator() {
        const unreadCount = this._emailModel.getUnreadCount();
        let buttonLabel = "";
        if (unreadCount > 0) {
            this._target.newItemNotification.visible = true;
            this._target.newItemNotification.gotoAndPlay(0);
            buttonLabel = `${unreadCount.toString()} new message(s)`;
            this._smartphoneButton.setLabel(buttonLabel);
        } else {
            this._target.newItemNotification.visible = false;
            this._smartphoneButton.setLabel("Open phone");
        }
    }

    _startShake() {
        this._shakeInterval = setInterval(() => {
            this._shake();
        }, 3000);
        this._shake();
    }

    _stopShake() {
        clearInterval(this._shakeInterval);
        createjs.Tween.removeTweens(this._target);
    }

    _shake() {
        const skinToShake = this._target;
        const props = { loop: 9, bounce: true };
        createjs.Tween.get(skinToShake, props).to({ x: skinToShake.startX + 2 }, 100);
    }
}